export default function Spinner() {
  return (
    <div>
      <div className="loader" />
      <div className="overlay" />
    </div>
  );
}
